import { useState } from "react";
import { toast } from "react-hot-toast";
import { Link } from "react-router-dom";

const PLANS = [
  { label: "1 000 Ft / hó", value: 1000 },
  { label: "2 500 Ft / hó", value: 2500 },
  { label: "5 000 Ft / hó", value: 5000 },
];

export default function IndividualSupport() {
  const [plan, setPlan] = useState(PLANS[1]);
  const [email, setEmail] = useState("");
  const [accept, setAccept] = useState(false);
  const [loading, setLoading] = useState(false);

  async function handleSubscribe() {
    if (!accept) return toast.error("Kérjük, fogadd el a feltételeket!");
    setLoading(true);
    try {
      const r   = await fetch("/api/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ amount: plan.value, email }),
      });
      const { gatewayUrl } = await r.json();
      window.location.href = gatewayUrl;
    } catch {
      toast.error("Nem sikerült csatlakozni a fizetési oldalhoz.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="mx-auto max-w-xl px-4 py-16 text-center space-y-10">
      <h1 className="text-3xl font-extrabold leading-tight md:text-4xl">
        Sok kicsi Folkra megy!
      </h1>

      <p className="mx-auto max-w-md text-gray-700 leading-relaxed">
        Tisztelt Folk kedvelő, kedves Balatonos rajongó!
      </p>

      <p className="mx-auto max-w-md text-gray-700 leading-relaxed">
        Itt van a lehetőség, hogy támogasd működésünket nem csak a programjainkon való részvételeddel, 
        hanem anyagi hozzájárulás formájában is.
        Támogass minket rendszeres havi utalásokkal az alábbi összegek közül választva, hogy hozzájárulj:
      </p>

      <ul className="mx-auto max-w-md space-y-2 text-left text-gray-700">
        <li>🤝 <b>Közösség építéséhez</b> – fiatalok százai találnak barátokra a próbateremben.</li>
        <li>🎶 <b>Élő hagyomány őrzéshez</b> – Történelmi Magyarország táncanyagai nem veszhetnek el.</li>
        <li>📜 <b>Átlátható gazdálkodáshoz</b> – éves beszámolóink nyilvánosak, minden forint útját látod.</li>
        <li>☕ <b>Minden csepp számít</b> – már 1 000 Ft/hó, kevesebb, mint egy kávé a Balaton partján.</li>
      </ul>

      <input
        type="email"
        required
        value={email}
        onChange={e => setEmail(e.target.value)}
        placeholder="E-mail címed"
        className="mb-6 w-full rounded border px-3 py-2"
      />

      <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:justify-center">
        {PLANS.map(p => (
          <button
            key={p.value}
            type="button"
            onClick={() => setPlan(p)}
            className={`rounded-md px-6 py-3 font-medium
              ${plan.value === p.value ? "bg-blue-900 text-white"
                                       : "bg-gray-200"}`}
          >
            {p.label}
          </button>
        ))}
      </div>

      <label className="mb-6 flex items-start gap-2 text-sm text-left max-w-xs mx-auto">
        <input
          type="checkbox"
          className="mt-1 h-4 w-4 shrink-0"
          checked={accept}
          onChange={e => setAccept(e.target.checked)}
          required
        />
        <span>
          Elfogadom az{" "}
          <Link to="/terms-of-use" target="_blank" className="underline text-primary">
            Általános Szerződési Feltételeket
          </Link>{" "}
          és az{" "}
          <Link to="/privacy-policy" target="_blank" className="underline text-primary">
            Adatkezelési tájékoztatót
          </Link>.
        </span>
      </label>

      <p className="mb-4 text-xs text-gray-600 max-w-xs mx-auto leading-snug">
        A „Támogatom” gomb megnyomásával jóváhagyod, hogy bankkártyádat a Barion
        tokenizálja, és a választott összeget havonta automatikusan levonja.
        A lemondás menetét az ÁSZF 5. pontja ismerteti.
      </p>

      <button
        disabled={!email || !accept || loading}
        onClick={handleSubscribe}
        className="rounded-md bg-emerald-600 px-8 py-3 font-semibold text-white
                   hover:bg-emerald-700 disabled:opacity-50"
      >
        {loading ? "Átirányítás…" : "Támogatom"}
      </button>
      <img
        src="./barion/barion-card-strip-intl__medium.png"
        alt="Barion – Biztonságos fizetés"
        className="mx-auto mt-12"
      />
      <p className="text-center text-xs text-gray-600 mt-2 max-w-xs mx-auto">
        A fizetés a Barion rendszerén keresztül történik. A bankkártya adatokat nem a szolgáltató,
        hanem a Barion kezeli. A Barion Payment Zrt. a Magyar Nemzeti Bank felügyelete alatt álló
        intézmény, engedélyének száma: H-EN-I-1064/2013.
      </p>
    </main>
  );
}
